export const NewPasswordRegexp: RegExp = new RegExp(
  '^(?=.*[a-z])(?=.*[A-Z])(?=.*\\d)(?=.*[\~\`!@#$%^&*()_{}[\\]:;\"\',.<>/?|\\\\+=-])[A-Za-z\\d\~\`!@#$%^&*()_{}[\\]:;\"\',.<>/?|\\\\+=-]{8,128}$'
);
